import {
  AzureB2CService,
  AuthConsumingService,
  analytics,
} from '@arm/ce-shared-components/components/Authentication';
import { getAppBaseUri, getSFaAuthConfig } from '../components/Authentication';

// Helper function to get user from session storage
const getUserFromSessionStorage = () => {
  try {
    const userData = sessionStorage.getItem('userData');
    return userData ? JSON.parse(userData) : null;
  } catch (error) {
    console.error('Error reading user data from session storage:', error);
    return null;
  }
};

export const azureInit = () => {
  // First check if we already have user data in session storage
  const existingUser = getUserFromSessionStorage();
  if (existingUser && existingUser.isAuth) {
    console.log('Found existing user data in session storage:', existingUser);
    return Promise.resolve(existingUser);
  }

  return AzureB2CService.init(AuthConsumingService, null, getSFaAuthConfig(), getAppBaseUri())
    .then(() => {
      // Check if user is already authenticated before attempting silent token refresh
      if (!AzureB2CService.isAuthenticated()) {
        return Promise.resolve({
          user: null,
          isAuth: false,
          isLoginDone: false,
        });
      }
      
      return AzureB2CService.getToken(undefined)
        .then(() => {
          const userData = {
            user: AzureB2CService.getUser(),
            isAuth: AzureB2CService.isAuthenticated(),
            isLoginDone: true,
          };
          
          // Save to session storage for persistence
          if (userData.isAuth && userData.user) {
            try {
              sessionStorage.setItem('userData', JSON.stringify(userData));
            } catch (error) {
              console.error('Error saving user data to session storage:', error);
            }
          }
          
          return userData;
        })
        .catch((error) => {
          console.error('Error getting token:', error);
          return null;
        });
    })
    .catch((error) => {
      console.error('Azure B2C initialization error:', error);
      return null;
    });
};
